import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ICompany, IListByFilterEmpresas } from 'src/app/pages/companies/models/company.interface';
import { CompanyService } from 'src/app/pages/companies/services/company.service';
import { IDashboard } from 'src/app/pages/dashboard/models/dashboard';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { SessionService } from 'src/app/shared/services/session.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DashboardsService } from '../../services/dashboards.service';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';

@Component({
  selector: 'app-my-dashboard-edit',
  templateUrl: './my-dashboard-edit.component.html',
  styleUrls: ['./my-dashboard-edit.component.scss']
})
export class MyDashboardEditComponent implements OnInit {
  @Output() closeModal = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter();
  @Input() dashboard!: IDashboard;

  form = new UntypedFormGroup({
    id: new UntypedFormControl('', [Validators.required]),
    tabName: new UntypedFormControl('', [Validators.required]),
    dashboardNumber: new UntypedFormControl('', [Validators.required]),
    companyId: new UntypedFormControl(null)
  });

  opcoesCompany: ICompany[] = [];

  constructor(
    private readonly dashboardsService: DashboardsService,
    private readonly companyService: CompanyService,
    private readonly toastService: ToastService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.form.patchValue(this.dashboard);
    this.getListCompany();

    const companyId = this.sessionService.getSession().companyId;
    if (companyId) {
      this.form.get('companyId')?.patchValue(companyId);
    }
  }

  save(): void {
    if (this.form.invalid) {
      this.toastService.toast('Preencha todos os campos obrigatórios antes de salvar.', EMessageType.Error);
      this.form.markAllAsTouched();
      return;
    }

    const dashboard = this.form.getRawValue();

    this.dashboardsService.editarMyDashboard(dashboard).subscribe((res) => {
      if (res.messages && res.messages.length > 0) {
        this.toastService.toast(res.messages);
      }

      if (res.isSucceed) {
        this.form.reset();
        this.recarregarListagem.emit();
        this.close();
      }
    });
  }

  close(): void {
    this.closeModal.emit();
  }

  private getListCompany(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const accountRole = this.sessionService.getSession().accountRole;
    const companyId = this.sessionService.getSession().companyId;

    const filtros: IListByFilterEmpresas = {
      pageNumber: 0,
      pageSize: 9999,
      orderBy: EOrdenacao.AlfabeticaAZ
    };

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    this.companyService.listarTodasEmpresas(filtros).subscribe((resposta) => {
      this.opcoesCompany = resposta.data;
    });
  }
}
